import { ReactNode, useState } from 'react';
import { PatientTopNav } from './PatientTopNav';
import { BottomNav } from '../common/BottomNav';
import { Home, Activity, FlaskConical } from 'lucide-react';

interface PatientLayoutProps {
  children: ReactNode;
  patientName?: string;
  adherenceScore?: number;
  currentView?: string;
  onNavigate?: (view: string) => void;
  onLogout?: () => void;
  hideBottomNav?: boolean;
  hideTopNav?: boolean;
  notificationCount?: number;
}

export function PatientLayout({
  children,
  patientName = 'Patient',
  adherenceScore = 0,
  currentView = 'dashboard',
  onNavigate,
  onLogout,
  hideBottomNav = false,
  hideTopNav = false,
  notificationCount = 0,
}: PatientLayoutProps) {
  // Bottom nav items
  const bottomNavItems = [
    { id: 'dashboard', label: 'Home', icon: Home },
    { id: 'vitals', label: 'Vitals', icon: Activity },
    { id: 'hometest-manage', label: 'Tests', icon: FlaskConical },
    { id: 'exercise-log', label: 'Exercise', icon: Activity },
  ];

  const handleNavigation = (view: string) => {
    if (onNavigate) {
      onNavigate(view);
    }
  };

  return (
    <div className="min-h-screen bg-[#D4F0F8] flex flex-col">
      {/* Top Navigation */}
      {!hideTopNav && (<PatientTopNav
        patientName={patientName}
        adherenceScore={adherenceScore}
        currentView={currentView}
        onNavigate={handleNavigation}
        onLogout={onLogout}
        notificationCount={notificationCount}
      />)}

      {/* Main Content */}
      <div className="flex-1 pb-20">
        {children}
      </div>

      {/* Bottom Navigation */}
      {!hideBottomNav && (
        <BottomNav
          items={bottomNavItems}
          activeItem={currentView}
          onItemClick={handleNavigation}
        />
      )}
    </div>
  );
}